import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ModalRegistro } from "./components/ModalRegistro";

import Home from "./pages/Home";
import BootCamp from "./pages/BootCamp";
import Academia from "./pages/Academia";
import Conocenos from "./pages/Conocenos";
import Viajes from "./pages/Viajes";
import { FAQ } from "./components/FAQ";
import Padres from "./pages/Padres";
import Sostenibilidad from "./pages/Sostenibilidad";

export default function App() {
  return (
    <>
      {/* Navbar Global */} <Navbar />
      {/* Rutas */}
      <Routes>
        {/* Página Principal */}
        <Route path="/" element={<Home />} />

        {/* Boot Camp */}
        <Route path="/bootcamp" element={<BootCamp />} />
        <Route
          path="/bootcamp/registro"element={<BootCamp />}
        />

        {/* Academia */}
        <Route path="/academia" element={<Academia />} />

        {/* Conocenos */}
        <Route path="/conocenos" element={<Conocenos />} />

        <Route path="/viajes" element={<Viajes />} />
        <Route path="/viajes/registro-miembro" element={<Viajes />} />

        <Route path="/sostenibilidad" element={<Sostenibilidad />} />

        {/* Redirección si la ruta no existe */}
        <Route path="*" element={<Navigate to="/" replace />} />

        <Route path="/preguntas-frecuentes" element={<FAQ />} />

        <Route path="/padres" element={<Padres />} />

      </Routes>
      {/* Componentes Globales */}
      <ModalRegistro />
      <Footer />
    </>
  );
}
